<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar :dateRangeMenu="false"></graph-tool-bar>
        </md-card-header>
        <md-card-content>
          <div v-if="showLoader" class="loader">
            <md-progress-spinner :md-diameter="64" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
          </div>

          <div v-else>
          <md-table v-model="appliancesData" table-header-color="green">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
<!--               <md-table-cell :md-label="$lang.general.imprint_id">{{ item.imprint.ID_imprint }}</md-table-cell> -->
              <md-table-cell :md-label="$lang.general.name">{{item.name }}</md-table-cell>
<!--               <md-table-cell :md-label="$lang.general.brand">{{item.brand}}</md-table-cell> -->
              <md-table-cell :md-label="$lang.charts.phase">{{item.phase}}</md-table-cell>
<!--               <md-table-cell :md-label="$lang.general.description">{{item.desc}}</md-table-cell> -->
              <md-table-cell :md-label="$lang.general.timestamp">{{item.imprint.timestamp}}</md-table-cell>
              <md-table-cell :md-label="$lang.charts.active_power">{{item.imprint.power_P}} W</md-table-cell>
              <md-table-cell :md-label="$lang.charts.reactive_power">{{item.imprint.power_Q}} VAr</md-table-cell>
              <md-table-cell :md-label="$lang.charts.current">{{item.imprint.power_I}} A</md-table-cell>
              <md-table-cell :md-label="$lang.general.action">
                <md-button @click="deleteImprint(item)" class="md-just-icon md-danger md-simple">
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <md-button @click="deleteAll()" class="md-danger">{{this.$lang.keys.delete_all}}</md-button>
          </div>

        </md-card-content>
      </md-card>
    </div>
    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import graphToolBar from "@/components/GraphToolBar";
import axios from "axios";
import snackBar from "@/components/SnackBar";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar
  },
  data() {
    return {
      appliancesData: [],
      showLoader: true
    };
  },
  computed: {
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    }
  },
  watch: {
    selectedDevice: function(newDevice, oldDevice) {
      if (newDevice.mac !== oldDevice.mac){
        this.getDataFromAPI();
      }
    }
  },
  mounted() {
    this.getDataFromAPI();
  },
  methods: {
    getDataFromAPI() {
      //this.showLoader = true;
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/nilm/appliances",
        data: {
          token: getSelectedDeviceToken(this.selectedDevice.mac)
        },
        withCredentials: true
      })
        .then(response => {
          if (response.data.status === "OK") {
            this.appliancesData = response.data.data;
            this.showLoader = false;
          }
        })
        .catch(error => {
          console.log(error);
          if (error.response.data.status == "FAIL") {
            this.showLoader = false;
            if (error.response.data.code == 610) {
              this.$refs.snackbar.notify(
                this.$lang.messages.appliances_imprints_not_found
              );
            }
          }
        });
    },
    deleteImprint(item) {
      axios({
        method: "DELETE",
        url: this.$ENDPOINTS.API_R + "/nilm/appliances",
        data: {
          token: getSelectedDeviceToken(this.selectedDevice.mac),
          ID: item.imprint.ID_imprint,
          remove: "IMPRINT"
        },
        withCredentials: true
      })
        .then(response => {
          if (response.data.status === "OK") {
            this.appliancesData = this.appliancesData.filter(
              el => el.imprint.ID_imprint !== item.imprint.ID_imprint
            );
            this.$refs.snackbar.notify(
              this.$lang.messages.success_removed_imprint
            );
          }
        })
        .catch(error => {
          if (error.response.data.status == "FAIL") {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    },
    deleteAll() {
      axios({
        method: "DELETE",
        url: this.$ENDPOINTS.API_R + "/nilm/appliances",
        data: {
          token: getSelectedDeviceToken(this.selectedDevice.mac),
          remove: "ALL"
        },
        withCredentials: true
      })
        .then(response => {
          if (response.data.status === "OK") {
            this.appliancesData = [];
            this.$refs.snackbar.notify(
              this.$lang.messages.success_removed_all_imprints
            );
          }
        })
        .catch(error => {
          if (error.response.data.status == "FAIL") {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    }
  },
  beforeDestroy(){
    delete this.appliancesData;
  }
};
</script>

<style lang="scss">
.md-ripple {
  position: unset;
}
.loader {
  text-align: center;
}
</style>

<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}
</style>

